var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.7584 16.8419L12.5 16.686L12.2416 16.8419L7.07613 19.9596L8.44693 14.0836L8.51549 13.7897L8.28739 13.5921L3.72308 9.63803L9.73227 9.12821L10.0327 9.10272L10.1504 8.82511L12.5 3.2813L14.8496 8.82511L14.9673 9.10272L15.2677 9.12821L21.2769 9.63803L16.7126 13.5921L16.4845 13.7897L16.5531 14.0836L17.9239 19.9596L12.7584 16.8419Z",
    fill: "#FABB12",
    stroke: "url(#paint0_linear_6699_4887)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6699_4887",
    x1: 12.5,
    y1: 2,
    x2: 12.5,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1110b01d8d85bbd6ab843c29c12cdbd4.svg";
export { ForwardRef as ReactComponent };